var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveBookMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#3D54CD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8334 27.5L20.0001 23.3333L14.1667 27.5V14.1667C14.1667 13.7246 14.3423 13.3007 14.6549 12.9882C14.9675 12.6756 15.3914 12.5 15.8334 12.5H24.1667C24.6088 12.5 25.0327 12.6756 25.3453 12.9882C25.6578 13.3007 25.8334 13.7246 25.8334 14.1667V27.5Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveBookMark);
export default __webpack_public_path__ + "static/media/ActiveBookMark.5dc657cf4a94d9d8a1706c2bc2fbae48.svg";
export { ForwardRef as ReactComponent };